import * as actionTypes from '../../constants/actionTypes';

const defaultState = {
    isLoading: false,
    errorMessage: null,
    isBasicUser: false,
    isProUser: false,
    userLoaded: false,
    isPaid: false
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case actionTypes.USER_DETAILS_FETCHING:
            return Object.assign({}, state, {
                isLoading: true,
                errorMessage: null,
                userLoaded: false
            });
        case actionTypes.USER_DETAILS_SUCCESS:
            let isBasicUser = false;
            let isProUser = false;
            let isPaid = false;
            action.results.map(function(result) {
                if (result === 'Basic') {
                    isBasicUser = true;
                    isPaid = true;
                }
                if (result === 'Pro') {
                    isProUser = true;
                    isPaid = true;
                }
                return null;
            });
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: null,
                isBasicUser: isBasicUser,
                isProUser: isProUser,
                isPaid: isPaid,
                userLoaded: true
            });
        case actionTypes.USER_DETAILS_FAILED:
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: action.errorMessage,
                isBasicUser: false,
                isProUser: false,
                isPaid: false,
                userLoaded: false
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userDetails.js